<div class="sticky" *ngIf="nav.visible">
	<header class="header">
		<div class="shell shell--size-1">
			<div class="header__inner">
				<!-- <a [routerLink]="['']" class="logo">
				</a> -->
				<a [routerLink]="['/']" class="logo" (click)="removePos()" style="width: 43rem">
					<img src="assets/img/Cosmic Algorithm Brand Assets-10.png" alt="Cosmic Algorithm Logo"
								loading="lazy">
				</a>
	
				<div class="header__aside">
					<nav class="nav hidden-xs">
						<ul>
							<li>
								<a [routerLink]="['/home/fxcm']">Home</a>
							</li>
	
							<li><a [routerLink]="['/home/fxcm']" fragment="about">About</a>
							</li>
							<!-- Home / About / Academy / Newsletter / Brochure -->
							<li>
								<!-- <a onClick="document.location='/#etoroLoc';">eToro</a> -->
								<a [routerLink]="['/academy']">Academy</a>
								
							</li>
							
							<li>
								<!-- <a onClick="document.location='/#backtesting';">Backtesting</a> -->
								<a [routerLink]="['/home/fxcm']" fragment="performance">Performance</a>
							</li>
							
							<li>
								<a [routerLink]="['/home/fxcm']" fragment="brochure">Brochure</a>
							</li>
						
						</ul>
					</nav><!-- /.nav -->
	
					<div class="header__actions">
						<button class="btn btn--secondary hidden-xs"><a style="all: unset;" [routerLink]="['/platform/profiles']">My Profile</a></button>
	
						<a [routerLink]="['/platform/live']" class="btn btn--size-1">Live</a>
	
						<a [routerLink]="['/platform/profiles']" class="btn btn--secondary btn--xs hidden visible-xs-inline-block">
							<img src="assets/img/svg/ico-profile.svg" alt="Click here for your profile"
								loading="lazy">
						</a>
	
	
					</div><!-- /.header__actions -->
					
				</div><!-- /.header__aside -->
			</div><!-- /.header__inner -->
		</div><!-- /.shell -->
	</header><!-- /.header -->
	</div>
	<script src="assets/vendor/jquery-3.6.0.min.js"></script>
	<script src="assets/js/bundle.js"></script>